import { useTranslation } from 'react-i18next';
import { Box } from 'src/components/Box';
import { Dialog } from 'src/components/Dialog';

import { CheckinBlockerContent } from './CheckinBlockerContent';
import { CheckinBlockerContentProps } from './_types';

export interface CheckInBlockerDialogProps
  extends Pick<
    CheckinBlockerContentProps,
    'users' | 'actions' | 'inlineActions' | 'showUserDetails'
  > {
  open: boolean;
  onClose: () => void;
  title?: string;
  subtitle?: string;
}

export function CheckInBlockerDialog({
  open,
  onClose,
  title,
  subtitle,
  users,
  actions,
  inlineActions = false,
  showUserDetails = false,
}: CheckInBlockerDialogProps) {
  const { t } = useTranslation('translation', { keyPrefix: 'checkinBlocker' });

  return (
    <Dialog
      open={open}
      onClose={onClose}
      title={title ?? t('title')}
      subtitle={subtitle}
      maxWidth="md"
    >
      <Box
        sx={{
          p: 2,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <CheckinBlockerContent
          users={users}
          actions={actions}
          inlineActions={inlineActions}
          showUserDetails={showUserDetails}
        />
      </Box>
    </Dialog>
  );
}
